<template>
  <b-container>
    <b-row>
      <b-col>
        <h1>Fragen und Antworten</h1>

        <h3>Was hat die Axel Springer SE bewogen, das Medienarchiv68 zu erstellen?</h3>
        <p>Bis heute wird die Berichterstattung der Medien von Axel Springer über „1968“ und die Studentenbewegung
          kontrovers diskutiert. Nicht selten geschieht dies ohne Kenntnis der Berichte selbst. Mit dem Medienarchiv68
          will die Axel Springer SE jedem den unkomplizierten Zugriff auf die Originalquellen ermöglichen, um sich
          selbst ein Bild zu machen. Rund 5.900 Beiträge, Kommentare, Leserbriefe, Karikaturen, Reportagen, Glossen und
          Interviews aus den Jahren 1966 bis 1968 zeigen, wie die Redaktionen von Axel Springer über die 68er-Bewegung
          berichtet haben. </p>
        <h3>Welche Medien wurden für die Erstellung der Datenbank ausgewertet?</h3>
        <p>Von den damaligen Medienangeboten des Verlags Axel Springer wurden ausgewertet: BERLINER MORGENPOST, BILD
          Berlin, B.Z., DIE WELT Berlin, HAMBURGER ABENDBLATT, WELT am SONNTAG, BILD am SONNTAG. Schwerpunktmäßig wurden
          die Berliner Zeitungen bzw. die Berliner Ausgaben der überregionalen Zeitungen von Axel Springer ausgewertet,
          da Berlin als so genannte „Frontstadt“ eine besonders wichtige Rolle 1968 spielte.&nbsp;In Ergänzung wurden in
          die Auswertung aufgenommen: DER TAGESSPIEGEL als eine repräsentative bürgerlich-liberale Stimme und der
          TELEGRAF als ein eher sozialdemokratisch orientiertes Berliner Blatt. Beide Zeitungen werden beispielhaft zu
          ausgewählten Ereignissen zitiert. Die Berichterstattung der Blätter des Verlags Axel Springer kann dadurch
          punktuell mit jener von Konkurrenzzeitungen verglichen werden.</p>
        <h3>Über welchen Zeitraum erstreckt sich die Auswertung?</h3>
        <p>Der Betrachtungszeitraum erstreckt sich vom Dezember 1966 bis Dezember 1968. Ab Dezember 1966 beginnen die
          Zeitungen von Axel Springer vermehrt über die Studentenbewegung zu berichten. Grund sind die einsetzenden
          Unruhen an der Freien Universität Berlin und mehrere gewaltsame Studenten-Demonstrationen in Berlin. Das Ende
          der Auswertung ist mit dem Jahresende 1968 und dem sukzessiven Nachlassen der Studentenproteste gesetzt.</p>
        <h3>Woran orientierte sich die thematische Auswahl der Artikel und wie sind diese in der Datenbank
          rubriziert?</h3>
        <p>Gesucht wurde nach allen Artikeln, die sich mit der Studentenbewegung im weitesten Sinne befasst haben.&nbsp;
          Zur leichteren Erschließung einzelner Aspekte wurden die Artikel nach Stichworten wie beispielsweise
          Schah/Ohnesorg/Kurras, Hochschulreform, SDS oder Kommune I unterteilt. Artikel, die sich keinem dieser
          Stichworte direkt zuordnen ließen, sind unter „Sonstiges“ zusammengefasst.</p>
        <h3>Wurden wirklich alle relevanten Artikel erfasst?</h3>
        <p>Wir haben uns bemüht, möglichst alle relevanten Artikel zu erfassen. Sollten Artikel fehlen,
          <b-link :to="{ name: 'contact' }">freuen wir uns über Hinweise per E-Mail</b-link>.
        </p>
        <p>Haben Sie weitere Fragen? Dann
          <b-link :to="{ name: 'contact' }">nehmen Sie bitte Kontakt mit uns auf</b-link>
        </p>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  import store from '@/store'

  export default {
    name: 'FaqPage',
    created () {
      store.commit('setBreadcrumb', [{ text: 'Über das Archiv', to: { name: 'about' } }, 'Fragen und Antworten'])
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/FAQPage.vue